"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPx = exports.PeriodCoordinateCoder = void 0;
const date_fns_1 = require("date-fns");
const addMinutes_1 = __importDefault(require("date-fns/addMinutes"));
const _1 = require(".");
/**
 * Period ←→ カレンダー上の座標の変換を行うCoder
 */
class PeriodCoordinateCoder {
    static encode(period, config) {
        return PeriodCoordinateEncoder.encode(period, config);
    }
    static decode(coordinate, config, roundMin) {
        return PeriodCoordinateDecoder.decode(coordinate, config, roundMin);
    }
}
exports.PeriodCoordinateCoder = PeriodCoordinateCoder;
/**
 * Period → 座標のEncoder
 */
class PeriodCoordinateEncoder {
    static encode(period, config) {
        return {
            left: this.encodeLeft(period, config),
            top: this.encodeTop(period, config),
            width: this.encodeWidth(period, config),
            height: this.encodeHeight(period, config)
        };
    }
    static encodeTop(period, config) {
        // FIXME:
        // この方法だとサマータイム切り替え日当日の表示が1時間ずれて、
        // おかしくなるが本当に修正が困難なので一旦許容する。
        // よっぽどサービスが大きくなったら直せばいい。
        // @see https://www.notion.so/865b7cda8ef64de9b1d18b57a0fe5cbe
        const minutesDiff = (0, date_fns_1.differenceInMinutes)(period.start, (0, date_fns_1.startOfDay)(period.start));
        return minutesDiff * config.heightPerMinute;
    }
    static encodeWidth(_period, config) {
        return config.widthPerDay;
    }
    static encodeHeight(period, config) {
        return period.lengthInMinutes() * config.heightPerMinute;
    }
}
PeriodCoordinateEncoder.encodeLeft = (period, config) => {
    const dayDiff = (0, date_fns_1.differenceInDays)(period.start, config.originDate);
    return dayDiff * config.widthPerDay;
};
/**
 * 座標 → PeriodのDecoder
 */
class PeriodCoordinateDecoder {
    static decode(coordinate, config, roundMin) {
        const start = this.decodeStart(coordinate, config, roundMin);
        const end = this.decodeEnd(coordinate, config, start);
        return new _1.Period(start, end);
    }
    static decodeStart(coordinate, config, roundMin) {
        const daysFromOrigin = coordinate.left / config.widthPerDay;
        const minutesFromOrigin = coordinate.top / config.heightPerMinute;
        const start = (0, date_fns_1.add)(config.originDate, {
            days: daysFromOrigin,
            minutes: minutesFromOrigin
        });
        return roundMin
            ? (0, date_fns_1.roundToNearestMinutes)(start, { nearestTo: roundMin })
            : start;
    }
    static decodeEnd(coordinate, config, start) {
        const heightMin = coordinate.height / config.heightPerMinute;
        return (0, addMinutes_1.default)(start, heightMin);
    }
}
const toPx = (coordinate) => {
    const { width, height, top, left } = coordinate;
    return {
        width: String(width) + 'px',
        height: String(height) + 'px',
        top: String(top) + 'px',
        left: String(left) + 'px'
    };
};
exports.toPx = toPx;
//# sourceMappingURL=periodCoordinateCoder.js.map